var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-list"},[_c('order-progress',{attrs:{"status":_vm.order.status,"is_canceled":_vm.order.is_canceled}}),_c('order-detail',{attrs:{"order":_vm.order}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }